import { GamesApi } from '../../../services/games-service';
import { getErrorMessage } from '../../../constants/utils';
import { error } from '../notifications';
import _, { differenceBy, filter, flatten, map } from 'lodash';
import { RetailersApi } from '../../../services/retailers-service';

export const GAME_ITEM_LIST = 'GAME_ITEM_LIST';
export const GAME_ITEM_LIST_LOADING = 'GAME_ITEM_LIST_LOADING';
export const GAME_ITEM_LIST_LOADING_DONE = 'GAME_ITEM_LIST_LOADING_DONE';
export const GAME_ITEM_LIST_SORTED = 'GAME_ITEM_LIST_SORTED';
export const GAME_LIST_INIT = 'GAME_LIST_INIT';
const gameItemsApi = new GamesApi();
const retailersApi = new RetailersApi();
export const getAllOrderableGameItems = (retailerType, jurisdiction) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: GAME_ITEM_LIST_LOADING });
            const state = getState();

            const isPostItem =
                state.frontendConfig.configs.find(
                    (co) => co.name === 'enable-pos-item',
                )?.value === 'true';
            let list = await gameItemsApi.getAllOrderableGameItems(
                retailerType,
                jurisdiction,
                isPostItem,
            );
            const gameIds = list.map((game) => game.id);
            if (
                state.frontendConfig.configs.find(
                    (co) => co.name === 'display-prize-levels-on-item-details',
                )?.value === 'true'
            ) {
                const prizeStructureOfAllGames =
                    await gameItemsApi.getPrizeStructure(gameIds);

                list = list.map((g) => {
                    const rows = prizeStructureOfAllGames?.[String(g.id)] ?? [];

                    const prizeStructure = [...rows].sort(
                        (a, b) => (b.prizeLevel ?? 0) - (a.prizeLevel ?? 0),
                    );

                    return { ...g, prizeStructure };
                });
            }

            dispatch({
                type: GAME_ITEM_LIST,
                list,
            });
        } catch (err) {
            dispatch(error({ msg: getErrorMessage(err) }));
            console.error(err);
        } finally {
            dispatch({ type: GAME_ITEM_LIST_LOADING_DONE });
        }
    };
};
export const getAllAdminGames = (isInstantTicket) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const isPostItem =
                state.frontendConfig.configs.find(
                    (co) => co.name === 'enable-pos-item',
                )?.value === 'true';
            const isPrizeStructureEnabled =
                state.frontendConfig.configs.find(
                    (co) => co.name === 'display-prize-levels-on-item-details',
                )?.value === 'true';
            dispatch({ type: GAME_ITEM_LIST_LOADING });

            let games = await gameItemsApi.getAllActiveLottoTickets(
                !isInstantTicket,
                isPostItem,
            );

            if (isPrizeStructureEnabled) {
                const gameIds = games.map((game) => game.id);

                const prizeStructureOfAllGames =
                    await gameItemsApi.getPrizeStructure(gameIds);

                games = games.map((g) => {
                    const rows = prizeStructureOfAllGames?.[String(g.id)] ?? [];

                    const prizeStructure = [...rows].sort(
                        (a, b) => (b.prizeLevel ?? 0) - (a.prizeLevel ?? 0),
                    );

                    return { ...g, prizeStructure };
                });
            }
            if (isInstantTicket) {
                dispatch({
                    type: GAME_ITEM_LIST,
                    list: games,
                });
            } else {
                const retailerTypes = await retailersApi.getRetailerTypes();
                const activeRetailerTypes = retailerTypes.filter(
                    (type) => type.isActive,
                );

                const gamesWithNoRetailerTypes = filter(
                    games,
                    (game) => !game.retailerType,
                );
                const fixedGames = flatten(
                    map(gamesWithNoRetailerTypes, (game) =>
                        map(activeRetailerTypes, (retailerType) => ({
                            ...game,
                            retailerType: retailerType.name,
                        })),
                    ),
                );

                const gamesWithRetailerTypes = differenceBy(
                    games,
                    gamesWithNoRetailerTypes,
                    'id',
                );
                const gamesWithActiveRetailerTypes = gamesWithRetailerTypes
                    .map((game) => {
                        game.retailerType = activeRetailerTypes.find(
                            (type) => type.reference === game.retailerType,
                        )?.name;
                        return game;
                    })
                    .filter((game) => !!game.retailerType);

                dispatch({
                    type: GAME_ITEM_LIST,
                    list: [...gamesWithActiveRetailerTypes, ...fixedGames],
                });
            }
        } catch (err) {
            dispatch(error({ msg: getErrorMessage(err) }));
            console.error(err);
        } finally {
            dispatch({ type: GAME_ITEM_LIST_LOADING_DONE });
        }
    };
};
export const setFilteredGames = (themes, searchText) => {
    return async (dispatch, getState) => {
        const games = getState().gameItems.content;

        let selectedGames = [...games];
        if (themes.length !== 0) {
            selectedGames = _.filter(
                selectedGames,
                (game) => themes.indexOf(game.themeName) !== -1,
            );
        }

        if (searchText && searchText.length > 0) {
            selectedGames = _.filter(
                selectedGames,
                (game) =>
                    game.name
                        .toLowerCase()
                        .includes(searchText.toLowerCase()) ||
                    game.reference
                        .toLowerCase()
                        .includes(searchText.toLowerCase()),
            );
        }
        dispatch({ type: GAME_ITEM_LIST_SORTED, payload: selectedGames });
    };
};

export const initGameList = () => {
    return async (dispatch) => {
        dispatch({ type: GAME_LIST_INIT });
    };
};
